import React from "react";

import Chart from "react-apexcharts";

import { donutChartConfig } from "../../../utils/chartConfigs";
import EmptyState from "../shared/EmptyState";

/**
 * Donut chart wrapper with optional center label override.
 *
 * @param {{
 *   series: number[],
 *   labels: string[],
 *   colors?: string[],
 *   height?: number,
 *   centerLabel?: string,
 *   centerValue?: string | number
 * }} props
 */
const DonutChart = ({
  series,
  labels,
  colors,
  height,
  centerLabel,
  centerValue,
}) => {
  // Empty / all-zero guard
  const hasData = series && series.length > 0 && series.some((v) => v > 0);

  if (!hasData) {
    return <EmptyState message="No data to display" />;
  }

  const config = donutChartConfig(series, labels);

  // Extract series from config, rest becomes options
  const { series: _series, ...options } = config;

  // Override colors when provided
  if (colors && colors.length > 0) {
    options.colors = colors;
  }

  // Override center donut label when both label and value are provided
  if (centerLabel && centerValue !== undefined) {
    options.plotOptions = {
      ...options.plotOptions,
      pie: {
        ...options.plotOptions?.pie,
        donut: {
          ...options.plotOptions?.pie?.donut,
          labels: {
            ...options.plotOptions?.pie?.donut?.labels,
            show: true,
            total: {
              ...options.plotOptions?.pie?.donut?.labels?.total,
              show: true,
              label: centerLabel,
              formatter: () => String(centerValue),
            },
          },
        },
      },
    };
  }

  return (
    <Chart
      height={height || 300}
      options={options}
      series={series}
      type="donut"
    />
  );
};

export default DonutChart;
